import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRainyLight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconRainyLight"><Path d="M11.25 15.75L10.25 17.75M13.5 18.5L12.5 20.5M9.42188 15.25H16.125C18.4032 15.25 20.25 13.3777 20.25 11.0682C20.25 8.75863 18.4032 6.88636 16.125 6.88636C15.9286 6.88636 15.7354 6.90028 15.5463 6.92719C15.0114 7.00333 14.4471 6.77668 14.1512 6.32464C13.1354 4.77296 11.3965 3.75 9.42188 3.75C6.28939 3.75 3.75 6.32436 3.75 9.5C3.75 12.6756 6.28939 15.25 9.42188 15.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconRainyLight;
